import ForgotPasswordInputForm from './ForgotPasswordInputForm';

export default ForgotPasswordInputForm;
